<template>
    <div>
        <DynamicIndex :codeModule="'epps'" :companyId="company_id" :permissionEdit="'empresa-editar-epps'" />
    </div>
</template>

<script>
import DynamicIndex from "@/views/form_builder/submissions/DynamicIndex";

export default {
  props: {
  },
    name: "EppsIndex",
    components: {
        DynamicIndex,
    },
    data() {
        return {
            company_id: this.$route.params.id,
        };
    },
};
</script>
